import { isVaultDataText, type VaultValue } from '@onefootprint/core';
import type { DataIdentifier } from '@onefootprint/request-types/dashboard';
import { format, parseISO } from 'date-fns';
import startCase from 'lodash/startCase';
import getDataLabel from '../get-data-label';

// Formats dates to be MM/dd/yyyy and strings to be title case. Preserve 2-letter country/state codes in uppercase.
const getDataValueString = (vaultValue: VaultValue, key: DataIdentifier) => {
  if (!vaultValue) {
    return '-';
  }
  const valueString = isVaultDataText(vaultValue) ? vaultValue : JSON.stringify(vaultValue);

  const field = getDataLabel(key);
  const titleCaseFields = [
    'full_name',
    'gender',
    'full_address',
    'issuing_country',
    'issuing_state',
    'document_type',
    'nationality',
    'curp',
  ];
  const dateFields = ['dob', 'issued_at', 'expires_at'];
  if (titleCaseFields.includes(field)) {
    return startCase(valueString.toLowerCase()).replace(/\b[a-zA-Z]{2}\b/g, match => match.toUpperCase());
  }
  if (dateFields.includes(field)) {
    return format(parseISO(valueString), 'MM/dd/yyyy');
  }
  if (field === 'ssn9' && valueString.length === 9) {
    return `${valueString.slice(0, 3)}-${valueString.slice(3, 5)}-${valueString.slice(5, 9)}`;
  }
  return valueString;
};

export default getDataValueString;
